export interface INotificationContentType {
	Id: number;
	Name: string;
	Description: string;
	Group: string;
	Email: boolean;
	Sms: boolean;
	Push: boolean;
}


export class EditNotificationContentTypeViewModel {
	id: number;
	name: string;
	description: string;
	group: string;
	email: boolean;
	sms: boolean;
	push: boolean;
	constructor(item?: INotificationContentType) {
		this.id = item && item.Id;
		this.name = item && item.Name;
		this.description = item && item.Description;
		this.group = item && item.Group;
		this.email = item && item.Email;
		this.sms = item && item.Sms;
		this.push = item && item.Push;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/NotificationContentType.ts